import React from "react";
import { Grid, Switch } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SettingsCard from "./SettingsCard";

const A2PApprovalSection = ({
  showLogin,
  showRegister,
  showAddNewBusiness,
  showFollow,
  showClaim,
  handleShowLoginChange,
  handleShowRegisterChange,
  handleShowAddNewBusinessChange,
  handleShowFollowChange,
  handleShowClaimChange,
}) => {
  return (
    <SettingsCard
      title="A2P Approval"
      subtitle='Temporarily disable "Login", "Register" & "Add New Business" links in the top menu and disable "Follow" & "Claim" buttons to pass A2P approval'
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch checked={showLogin} onChange={handleShowLoginChange} />
            <SoftTypography variant="body2" sx={{ marginLeft: "10px", fontSize: "14px" }}>
              Show Login link in top menu
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch checked={showRegister} onChange={handleShowRegisterChange} />
            <SoftTypography variant="body2" sx={{ marginLeft: "10px", fontSize: "14px" }}>
              Show Register link in top menu
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch
              checked={showAddNewBusiness}
              onChange={handleShowAddNewBusinessChange}
            />
            <SoftTypography variant="body2" sx={{ marginLeft: "10px", fontSize: "14px" }}>
              Show Add New Business link in top menu
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch checked={showFollow} onChange={handleShowFollowChange} />
            <SoftTypography variant="body2" sx={{ marginLeft: "10px", fontSize: "14px" }}>
              Show Follow button in listing detail
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12}>
          <SoftBox display="flex" alignItems="center" mb={1}>
            <Switch checked={showClaim} onChange={handleShowClaimChange} />
            <SoftTypography variant="body2" sx={{ marginLeft: "10px", fontSize: "14px" }}>
              Show Claim button in listing detail
            </SoftTypography>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default A2PApprovalSection;
